export default [
  // gathered resources
  [
    {name: 'food', quantity: 0, icon: 'mdi-barley'},
    {name: 'wood', quantity: 0, icon: 'mdi-pine-tree'},
    {name: 'stone', quantity: 0, icon: 'mdi-cloud'}
  ],
  // found resources
  [
    {name: 'skin', quantity: 0, icon: 'mdi-cow'},
    {name: 'herbs', quantity: 0, icon: 'mdi-mushroom'},
    {name: 'ore', quantity: 0, icon: 'mdi-rhombus-medium'}
  ],
  // refined resources
  [
    {name: 'leather', quantity: 0, icon: 'mdi-thumb-up'},
    {name: 'peity', quantity: 0, icon: 'mdi-christianity'},
    {name: 'metal', quantity: 0, icon: 'mdi-instapaper mdi-rotate-90'}
  ]
]
